import 'react-toastify/dist/ReactToastify.css'
import '../styles/reactToastify.scss'

import { ThemeProvider } from '@emotion/react'
import CssBaseline from '@mui/material/CssBaseline'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { ToastContainer } from 'react-toastify'
import i18n from '../i18n'
import AppRoutes from './appRoutes'
import theme from './theme'

const App = () => {
  const intl = useIntl()
  useEffect(() => {
    const updateTitle = () => {
      document.title = intl.formatMessage({ id: 'document.title' })
    }

    updateTitle()
    i18n.on('languageChanged', updateTitle)
    return () => {
      i18n.off('languageChanged', updateTitle)
    }
  }, [i18n, intl])

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-right" />
      <CssBaseline />
      <AppRoutes />
    </ThemeProvider>
  )
}

export default App
